import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../../../environments/environment';
import { Category } from '../../../../core/services/categories/category.model';

@Injectable()
export class SubcategoriesService implements Resolve<any>
{
    categories: any[];
    onCategoryChanged: BehaviorSubject<any> = new BehaviorSubject({});
    onProductsChanged: BehaviorSubject<any> = new BehaviorSubject({});
    routeParams: any;
    category: any;

    constructor(
        private http: HttpClient
    ) {}

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {

            Promise.all([
                this.getCategories(),
                this.getCategory()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCategories(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this.http.get<Category[]>(`${environment.apiUrl}/categories`)
                .subscribe((response) => {
                    this.categories = response.filter(c => c.parentCategory === this.routeParams.id);
                    this.onProductsChanged.next(this.categories);
                    resolve(this.categories);
                }, reject);
        });
    }

    getCategory(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this.http.get<Category>(`${environment.apiUrl}/categories/${this.routeParams.id}`)
                .subscribe((response) => {
                    this.category = response;
                    this.onCategoryChanged.next(this.category);
                    resolve(response);
                }, reject);

        });
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/subcategories/subcategories.service.ts